import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Title from '../Complements/Title';
import SelectForm from '../Complements/SelectForm';
import DateFnsUtils from '@date-io/date-fns';
import "moment/locale/es";
import esLocale from "date-fns/locale/es";
import SearchIcon from '@material-ui/icons/Search';

import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from '@material-ui/pickers';
import { Grid, Button, FormControl, InputLabel, Select, MenuItem, CircularProgress } from '@material-ui/core';
// import MaterialTable from 'material-table';

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import './../Codes/style/tableresponsive.css';

import Pagination from '@material-ui/lab/Pagination';
import Alert from '@material-ui/lab/Alert';


const DepositList = props => {
    const { loading, depositsPaginate, count, page, onChangePaginationDeposits, classes, selectDeposit, dateValue, dateStartDeposits,
        dateEndDeposits, handleDateStart, handleDateEnd, findDataRange, findDeposit, depositSelected } = props
    const [ deposit ] = useState(depositSelected[0])
    // const [ data, setData ] = useState([])
    const handleSubmit = (val) => {
       //  console.log(val)
    }
    const renderTableMovements = () => {
        if (loading) {
            return <CircularProgress />
        } else {
            if (depositsPaginate.length > 0) {
                return  <div>
                        <Grid item xs={12} md={12} lg = {12}>
                            <Table id='table'>
                                <Thead>
                                    <Tr>
                                        <Th>Fecha</Th>
                                        <Th>Transacción</Th>
                                        <Th>Valor</Th>
                                        <Th>Saldo</Th>
                                        <Th>Oficina</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    { 
                                        
                                        depositsPaginate.map(row => (
                                            <Tr key={row.Fecha}>
                                                <Td>{row.Fecha}</Td>
                                                <Td>{row.Transaccion}</Td>
                                                <Td>{row.Valor}</Td>
                                                <Td>{row.Saldo}</Td>
                                                <Td>{row.Oficina}</Td>
                                            </Tr>
                                        ))
                                        
                                    }
                                    
                                </Tbody>
                            </Table>
                        </Grid>
                            <Pagination 
                                count = { count } 
                                color = "primary" 
                                page = { page }
                                onChange = { onChangePaginationDeposits }
                            />
                        </div>
            } else {
                return <Alert severity="info">No se han encontrado movimientos en el mes seleccionado.</Alert>
            }
        }
    }
    return (
        <div>
            <Grid container spacing={3}>
                <Grid item xs={12} md={8} lg = {8} sm = {12}>
                    <Title>Depositos a Plazo Fijo </Title>
                </Grid>
                <Grid item xs={12} md={4} lg = {4} sm = {12}>
                <FormControl variant="outlined" style={{maxWidth: '100%'}}>
                    <InputLabel id="demo-simple-select-outlined-label">Seleccione un deposito</InputLabel>
                    <Select
                    label="Seleccione un depósito"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    defaultValue={deposit}
                    onChange={(e) => findDeposit(e.target.value) }
                    >
                        {
                            depositSelected.map(option => {
                            return <MenuItem key={option.Secuencial} value={option}>{`${option.TipoDeposito}`}</MenuItem>
                            })
                        }
                    </Select>
                </FormControl>
                </Grid>
            </Grid>
            <SelectForm
                name = { 'Período' }
                label = { 'Seleccione período '}
                // data = { [{ id: '1', name: 'data'}] }
                classes = { classes }
                dateValue = { dateValue }
                onSelected = { (val) => selectDeposit(val)}
                onSubmit={ handleSubmit }
            ></SelectForm>
            <br></br>
             <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Grid container justify="center" spacing={3}  alignItems="flex-end">
                        <Grid item md={4} sm={12} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                <KeyboardDatePicker
                                    // disableToolbar
                                    // variant="inline"
                                    autoOk
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    margin="normal"
                                    id="date-start"
                                    label="Fecha de inicio"
                                    value={dateStartDeposits}
                                    onChange={handleDateStart}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={4} sm={12} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                <KeyboardDatePicker
                                    // disableToolbar
                                    autoOk
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    margin="normal"
                                    id="date-end"
                                    label="Fecha de fin"
                                    value={dateEndDeposits}
                                    onChange={handleDateEnd}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={4} sm={12} xs={12}>
                            <Button 
                            variant="contained"
                            color="primary"
                            onClick = { findDataRange }
                            style= {{ backgroundColor:'#00a0af'}}
                            endIcon={<SearchIcon/>}
                            >
                                Buscar
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <br/> <br/>
            <Grid container justify="center" spacing={3}  alignItems="center">
                {
                    renderTableMovements()
                }
            </Grid>
        </div>
    );
};

DepositList.propTypes = {
    codes: PropTypes.array.isRequired,
    classes: PropTypes.object.isRequired,
    // urlPath: PropTypes.string.isRequired,
};


export default DepositList;

